import {pickBy} from 'lodash-es'

export type ContainerChildren<T extends object | undefined> = (options: T) => React.ReactNode

let propertyNameI = 0
/**
 * Создает имя для prop'ы, которая используется только для внутренних нужд
 */

export function generatePropertyName (): string {
  return `__HIDDEN_PROPERTY_${propertyNameI++}__`
}

const ARIA_DATA_PROPS_PREFIX = ['data-', 'aria-']

export function pickDataAndAriaProps<T extends object> (props: T) {
  return pickBy(props, ((_val, key) => ARIA_DATA_PROPS_PREFIX.some((v) => key.startsWith(v))))
}
